import { IXMLSidebarData } from 'utils/aws-s3-helper';
import { AccordionSidebarItem } from './accordion-sidebar-item';
import { AccordionSidebarGroup, IAccordionSidebarGroupProps } from './accordion-sidebar-group';
import styles from './accordion-list.module.scss';

export interface IAccordionSidebarProps extends Omit<IAccordionSidebarGroupProps, 'groups'> {
	sidebar: IXMLSidebarData;
	archiveTitle?: string;
	currentYearTitle?: string;
}

export const AccordionSidebar = ({
	sidebar,
	slug,
	archiveTitle,
	currentYearTitle,
	link
}: IAccordionSidebarProps): React.JSX.Element => (
	<aside className={styles.sidebar}>
		{sidebar.thisYearFiles && (
			<>
				{currentYearTitle && <h4>{currentYearTitle}</h4>}
				<AccordionSidebarItem files={sidebar.thisYearFiles} slug={slug} />
			</>
		)}

		{sidebar.oldFiles && (
			<>
				{archiveTitle && <h4>{archiveTitle}</h4>}
				<AccordionSidebarGroup groups={sidebar.oldFiles} slug={slug} link={link} />
			</>
		)}
	</aside>
);

export default AccordionSidebar;
